import {
  AutocompleteUniselection,
  YesObject
} from '@yes.technology/react-toolkit'
import { ComponentProps } from 'react'

type Option = ComponentProps<typeof AutocompleteUniselection>['options'][0]

type UniselectionRelationProps = {
  label: string
  statusClass: 'processing' | 'default'
  suggestions: YesObject[]
  value: string
  options: Option[]
  inputRef?: React.Ref<HTMLInputElement>
  informational?: boolean
  onChangeObjects: (objects: YesObject[]) => void
  onChangeValue: (value: string) => void
}

const UniselectionRelation = ({
  inputRef,
  label,
  statusClass,
  suggestions,
  value,
  options,
  informational,
  onChangeObjects,
  onChangeValue
}: UniselectionRelationProps) => {
  const handleChange = (
    targetSelection: string | { uuid: string; des: string }
  ) => {
    const targetSelectionValue =
      typeof targetSelection === 'string'
        ? targetSelection
        : targetSelection.des
    onChangeValue(targetSelectionValue)
    if (targetSelectionValue === '') {
      return onChangeObjects([])
    }

    const option = suggestions.find(
      (suggestion) => suggestion.des === targetSelectionValue
    )

    if (!option) return

    onChangeObjects([option])
  }

  return (
    <AutocompleteUniselection
      ref={inputRef}
      onChange={handleChange}
      {...{
        informational,
        label,
        statusClass,
        value,
        options
      }}
    />
  )
}

export default UniselectionRelation
